import { SET_ALERT } from './types';

export default (payload: unknown) => ({
  type: SET_ALERT,
  payload,
});
